import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLogger } from 'hook/error.hook';
import useIncomeInput from 'pages/Profile/pages/ProfileOverview/hooks/useIncomeInput';
import useDirtyData from 'pages/Profile/pages/ProfileOverview/hooks/useDirtyData';
import { saveProfileOverview } from 'pages/Profile/pages/ProfileOverview/actions/saveProfileOverview.action';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { unFormatCurrency } from 'helpers/money.helper';
import { setIsTimeToRecertifyIncomeUpdated } from 'helpers/localstorage';

export const useSelfReportedIncomeModule = (defaultValues, eventHandler) => {
  const annualIncomeInput = useIncomeInput(defaultValues.annualIncome);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(
    defaultValues.isDefaultDisabled,
  );

  const dirtyData = useDirtyData({ incomeSource: 'OVERVIEW' });
  const dispatch = useDispatch();

  const logger = useLogger({
    name: 'SelfReportedIncome.hook',
  });

  const onChangeIncome = e => {
    const { value } = e.target;
    const formattedValue = unFormatCurrency(value);
    if (/^[0-9]+$/i.test(formattedValue) || formattedValue === '') {
      setIsSubmitDisabled(value === '$' || value === '');
      annualIncomeInput.update(value);
      dirtyData.processDirtyData(
        'annualIncome',
        annualIncomeInput.trimIncome(value),
        defaultValues.annualIncome.toString(),
      );
    } else {
      return false;
    }
  };

  const handleUpdate = async (data, type) => {
    setIsSubmitDisabled(true);
    try {
      await dispatch(saveProfileOverview(data, type));
      setIsTimeToRecertifyIncomeUpdated(true);
      logger.showSuccess(
        'You successfully updated your individual annual income',
      );
    } catch (error) {
      const errorMessage =
        'Unable to update your individual annual income. Please try again later';
      logger.reportAPIError(error);
      logger.error(errorMessage);
      logger.showError(errorMessage);
    }
  };

  const onClickSubmit = e => {
    e.preventDefault();
    eventHandler(CLICK, {
      'Click Type': 'Save Income Update',
      'Module Heading': 'Is your income correct?',
    });
    handleUpdate(dirtyData.data);
  };

  return {
    annualIncomeInput,
    onChangeIncome,
    onClickSubmit,
    isSubmitDisabled,
  };
};
